export type LocalState = "RJ" | "SP";

export function normalizeLocalState(value?: string | null): LocalState | null {
  const normalizedState = value?.trim().toUpperCase();

  return normalizedState === "RJ" || normalizedState === "SP"
    ? normalizedState
    : null;
}

export function getLocalStateParam(
  searchParams: URLSearchParams,
  key = "state",
  fallback: LocalState = "SP",
): LocalState {
  return normalizeLocalState(searchParams.get(key)) ?? fallback;
}

export function getLocalStateFromName(localName?: string | null): LocalState | null {
  const normalized =
    localName?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() ?? "";

  if (normalized.includes("rio de janeiro") || normalized === "rj") return "RJ";
  if (normalized.includes("sao paulo") || normalized === "sp") return "SP";

  return null;
}
